import parse from 'html-react-parser'
import { EmptyCell, Typography } from 'shared/ui'
import {
  type ICallingListResponse,
  type IResponseFullAICallingAgent,
} from 'entities/AICalling/api/types'
import { AiCallingStatus } from 'entities/AICalling/ui/AiCallingStatus/AiCallingStatus'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { textToHtml } from 'entities/Message/lib/textToHtml'
import styles from './styles.module.scss'

export const Content = ({ item }: { item: ICallingListResponse | IResponseFullAICallingAgent }) => {
  const entities = useEntitiesContext()
  const { name, status, greeting_message, instructions } = item
  return (
    <div className={styles.wrap}>
      <div>
        <Typography ariaLabel={'name'} variant={'heading-lg'} ellipsis>
          {name}
        </Typography>
        <div className={styles.info}>
          <AiCallingStatus status={status} />
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.row}>
          <div className={styles.title}>
            <Typography
              ariaLabel={'title'}
              variant={'text-input-field-r'}
              color={'tertiary'}
              ellipsis
              className={styles.content}
            >
              Greeting message
            </Typography>
          </div>
          <div className={styles.value}>
            <Typography ariaLabel={'value'} variant={'body-rg-regular'} className={styles.content}>
              {greeting_message || <EmptyCell />}
            </Typography>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.title}>
            <Typography
              ariaLabel={'title'}
              variant={'text-input-field-r'}
              color={'tertiary'}
              ellipsis
              className={styles.content}
            >
              Agent instructions
            </Typography>
          </div>
          <div className={styles.value}>
            <Typography ariaLabel={'value'} variant={'body-rg-regular'} className={styles.content}>
              {instructions ? (
                parse(
                  textToHtml(entities, {
                    replaceNewRow: true,
                    text: instructions,
                    noReplaceMergeField: true,
                  })
                )
              ) : (
                <EmptyCell />
              )}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}
